import enrollCmd from "../base/enrollCmd";
import mdeFormatType from "../base/mdeFormatType";
import { IPluginEnroll } from "../base/pluginModels";
import { isPluginEnrollInterface } from "../decodePluginMsg";
import { IPluginCards, IPluginCard } from "./cardModels";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager
 * @param formatType
 */
export const enrollMDEMsg = (formatType?) => {
    const formatTypeSelected = formatType ? formatType : mdeFormatType.DUAL;
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_MDE + "','formatType':'" + formatTypeSelected + "'}";
    return enrolMessage;
};

/**
  * converts the message to object type IPluginCards.
  * @param {*} obj
  */
export const decodeMDEPluginMsg = (obj) => {
    let mdeResult = {} as IPluginCards;

    if (isPluginEnrollInterface(obj)) {
        let jsonObj = {} as IPluginEnroll;
        if (typeof obj === "string") {
            jsonObj = JSON.parse(obj);
        }

        let mdeCard1 = {} as IPluginCard;
        let mdeCard2 = {} as IPluginCard;

        var cardData = jsonObj.enrollData.split(";");
        if (cardData[1] !== undefined) {
            // there is 2 card results, would be from a DUAL_TAG enroll
            //tag low
            var tagLow = cardData[0];
            // data within this json object is an 'array' of different items split by ':'
            var tagLowDetails = tagLow.split(":");
            // each 'array' item has a key/value structure split by '='.
            var tagLowNumberDetails = tagLowDetails[0].split("=");
            if (tagLowNumberDetails[1] !== '0') {
                mdeCard1.cardType = tagLowNumberDetails[1];
                mdeCard1.formatType = tagLowDetails[1].split("=")[1];
                mdeCard1.cardNumber = tagLowDetails[2].split("=")[1];
                mdeCard1.cardHex = tagLowDetails[3].split("=")[1];
                mdeCard1.cardNoBits = parseInt(tagLowDetails[4].split("=")[1]);
            }
            //tag high
            var tagHigh = cardData[1];
            var tagHighDetails = tagHigh.split(":");
            var tagHighNumberDetails = tagHighDetails[0].split("=");
            if (tagHighNumberDetails[1] !== '0') {
                mdeCard2.cardType = tagHighNumberDetails[1];
                mdeCard2.formatType = tagHighDetails[1].split("=")[1];
                mdeCard2.cardNumber = tagHighDetails[2].split("=")[1];
                mdeCard2.cardHex = tagHighDetails[3].split("=")[1];
                mdeCard2.cardNoBits = parseInt(tagHighDetails[4].split("=")[1]);
            }
            mdeResult.cards = [mdeCard1, mdeCard2];
        }
        else {
            // only 1 card result, would be from a HIGH_TAG or LOW_TAG enroll
            var tag = cardData[0];
            var tagDetails = tag.split(":");
            var tagNumberDetails = tagDetails[0].split("=");
            mdeCard1.cardType = tagNumberDetails[1];
            mdeCard1.formatType = tagDetails[1].split("=")[1];
            mdeCard1.cardNumber = tagDetails[2].split("=")[1];
            mdeCard1.cardHex = tagDetails[3].split("=")[1];
            mdeCard1.cardNoBits = parseInt(tagDetails[4].split("=")[1]);
            mdeResult.cards = [mdeCard1];
        }
    }
    return mdeResult;
};
